<template>
  <div id="app">
    <router-view v-if="!loading" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      loading: true,
      timer: null,
    };
  },
  methods: {
    async getConfig() {
      await this.$axios.get("/config").then((response) => {
        const data = response.data;
        if (data.code == 200) {
          this.loading = false;
          this.$store.state.config = data.data;
          document.title = data.data.webTitle;
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = this.$axios.defaults.imgURL + this.$store.state.config.webIcon;
          this.$store.state.i18n =  data.data.defaultLang;
          document.getElementsByTagName('head')[0].appendChild(link);
        } else {
          //网站被关闭
          alert(data.message);
        }
      });
    },
    async getUserInfo() {
      if (localStorage.getItem("X-Token")) {
        await this.$axios.get("/info").then((res) => {
          const data = res.data;
          if (data.code == 200) {
            this.$store.state.user = data.data;
            if (data.data.checkPhone == 0) {
              if (this.$route.name != 'memberIndex') {
                this.$router.push({
                  path: "member/index",
                });
              }
            }
          }
        });
      } else {

      }
    },

  },
  watch: {
    $route() {
      console.log('路由变化');
    }
  },
  created() {
    this.getConfig();
    this.timer = setInterval(() => {
      this.getUserInfo();
    }, 1000);
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue